import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { Box, xcss, Inline, Grid } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { StandupStoreContainer } from '../controllers/store';
import { StandupTimerStoreContainer } from '../controllers/timer-store';
import messages from './messages';
import { ParticipantList } from './participant';
import Timer from './timer';

export const StandupPanel = () => {
	const { formatMessage } = useIntl();

	return (
		<StandupStoreContainer>
			<StandupTimerStoreContainer>
				<Box
					xcss={componentStyles}
					paddingInline="space.150"
					paddingBlock="space.100"
					testId="standups.ui.wrapper"
				>
					<Grid gap="space.150">
						<Inline xcss={inlineSettingHeaderStyles} spread="space-between">
							<Heading size="xsmall">{formatMessage(messages.standupNonfinal)}</Heading>
							<IconButton
								label={formatMessage(messages.closeLabelNonFinal)}
								icon={CrossIcon}
								appearance="subtle"
							/>
						</Inline>
						<Timer />
						<ParticipantList />
					</Grid>
				</Box>
			</StandupTimerStoreContainer>
		</StandupStoreContainer>
	);
};

const componentStyles = xcss({
	color: 'color.text',
	width: '272px',
	borderRadius: 'border.radius.300',
	border: `1px solid ${token('color.border')}`,
	marginBottom: 'space.300',
	marginLeft: 'space.300',
	marginRight: 'space.negative.300',
	zIndex: 'card',
});

const inlineSettingHeaderStyles = xcss({
	alignItems: 'center',
});
